export default __webpack_public_path__ + "static/media/I0000.b92e9460.png";